const meta = {
  i18n: {
    zh_CN: () => require("@/i18n/lang/invite/zh.js"),
    en_US: () => require("@/i18n/lang/invite/en.js"),
    // ko_KR: () => require("@/i18n/lang/invite/kr.js"),
    zh_TW: () => require("@/i18n/lang/invite/tw.js"),
  },
};
export default [
  {
    path: "/v3",
    name: "kyc",
    redirect: "/v3/kyc",
    meta,
    component: () => import("@/layout/index"),
    children: [
      // {
      //   path: "kyc",
      //   component: () => import("@/pages/v2/kyc"),
      // },
      {
        path: "primary",
        name:'kycPrimary',
        component: () => import("@/pages/v2/kyc/primary"),
      },
      {
        path: "primary/photo",
        name: 'kycPrimaryPhoto',
        component: () => import("@/pages/v2/kyc/primary/idPhoto"),
      },
      {
        path: "review",
        name:'kycReview',
        component: () => import("@/pages/v2/kyc/review"),
      },
      {
        path: "premium",
        name:'kycPremium',
        component: () => import("@/pages/v2/kyc/premium"),
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/v2/kyc.js